<mat-accordion displayMode="flat" multi="true" style="display:block">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      {{driverReport.driverName}}
    </mat-expansion-panel-header>
    <div>
      <div style="margin-left:10px;margin-top:20px">
        <span>
          <mat-label class="driverLabel">Skiftlängd:</mat-label>&nbsp;
          <mat-label class="driverInfo">{{driverReport.totalShiftDuration}}</mat-label>
        </span>
        &nbsp;
        <span>
          <mat-label class="driverLabel">Effektiv arbetstid:</mat-label>&nbsp;
          <mat-label class="driverInfo">{{driverReport.totalAssignedDuration}}</mat-label>
        </span>

        <div>
          <div>
            <ag-grid-angular style="width:450px;height:200px;margin-top:10px" #shifts
                             class="ag-theme-material"
                             [rowData]="this.driverReport.shifts"
                             [gridOptions]="gridOptionsWs">
            </ag-grid-angular>
          </div>
        </div>
        <div [hidden]="!driverReport">
          <mat-accordion displayMode="flat" multi="true" style="display:block">
            <mat-expansion-panel *ngFor="let assignment of driverReport.assignments">
              <mat-expansion-panel-header>
                <span *ngIf="isAdminOrMisc(assignment)">
                  <mat-icon style="margin-right:10px" *ngIf="!getEvent(assignment).isSvgIcon">{{getIcon(assignment)}}</mat-icon>
                  <mat-icon style="margin-right:10px" *ngIf="getEvent(assignment).isSvgIcon" svgIcon="{{getEvent(assignment).icon}}"></mat-icon>{{assignment.description}}
                </span>
                <span *ngIf="!isAdminOrMisc(assignment)"><mat-icon style="margin-right:10px">{{getIcon(assignment)}}</mat-icon>{{assignment.description}}</span>
              </mat-expansion-panel-header>
              <div style="width:750px" data-cy="reportBlockInfo">
                <span *ngIf="assignment.aircraft">
                  <mat-label class="driverLabel">Typ:</mat-label>
                  <mat-label class="driverInfo">{{assignment.aircraft}}</mat-label>
                </span>
                <span *ngIf="assignment.aircraftRegistration">
                  <label class="driverLabel">Reg:</label>
                  <label class="driverInfo">{{assignment.aircraftRegistration}}</label>
                </span>
                <span *ngIf="assignment.destination">
                  <label class="driverLabel">Dest:</label>
                  <label class="driverInfo">{{assignment.destination}}</label>
                </span>
                <span *ngIf="assignment.blockTime">
                  <label class="driverLabel">Block tid:</label>
                  <label class="driverInfo">{{getTime(assignment.blockTime)}}</label>
                </span>
                <span *ngIf="assignment.scheduledTime">
                  <label class="driverLabel">planerad tid:</label>
                  <label class="driverInfo">{{getTime(assignment.scheduledTime)}}</label>
                </span>
                <span *ngIf="assignment.diIndicator">
                  <label class="driverLabel">DI:</label>
                  <label class="driverInfo">{{assignment.diIndicator}}</label>
                </span>
                <span *ngIf="assignment.flightServiceType">
                  <label class="driverLabel">Service typ:</label>
                  <label class="driverInfo">{{assignment.flightServiceType}}</label>
                </span>
                <span *ngIf="assignment.gate">
                  <label class="driverLabel">Gate:</label>
                  <label class="driverInfo">{{assignment.gate}}</label>
                </span>
                <span *ngIf="assignment.stand">
                  <label class="driverLabel">Stand:</label>
                  <label class="driverInfo">{{assignment.stand}}</label>
                </span>
                <span *ngIf="assignment.personsOnBoard">
                  <label class="driverLabel">Pax:</label>
                  <label class="driverInfo">{{assignment.personsOnBoard}}</label>
                </span>
                <span *ngIf="!isTransfer(assignment)">
                  <label class="driverLabel">Faktureras:</label>
                  <label class="driverInfo">{{assignment.isInvoiced ? "Ja" : "Nej"}}</label>
                </span>
                <span *ngIf="assignment.gate">
                  <label class="driverLabel">Gate:</label>
                  <label class="driverInfo">{{assignment.gate}}</label>
                </span>
                <span *ngIf="assignment.stand">
                  <label class="driverLabel">Stand:</label>
                  <label class="driverInfo">{{assignment.stand}}</label>
                </span>
                <span *ngIf="assignment.terminal">
                  <label class="driverLabel">Term:</label>
                  <label class="driverInfo">{{assignment.terminal}}</label>
                </span>
              </div>

              <ag-grid-angular style="width:800px;height:350px;margin-top:10px" #activities
                               [gridOptions]="gridOptionsAct"
                               [rowData]="assignment.activities">
              </ag-grid-angular>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <div *ngIf="!driverReport.assignments">
          <a mat-list-item>Aktiviteter saknas.</a>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
